/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Session_Completed_StatusInputs */

const fr_session_completed_status = /** @type {(inputs: Session_Completed_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Section terminée`)
};

/**

* @param {Session_Completed_StatusInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const session_completed_status = /** @type {((inputs?: Session_Completed_StatusInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Session_Completed_StatusInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_session_completed_status(inputs)
});